import { Package } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const PRESETS = [
  { key: "envelope", label: "Envelope", v: { weight_lb: 1, weight_oz: 0, length_in: 12, width_in: 9, height_in: 1 } },
  { key: "small", label: "Small box", v: { weight_lb: 2, weight_oz: 0, length_in: 8, width_in: 6, height_in: 4 } },
  { key: "medium", label: "Medium box", v: { weight_lb: 5, weight_oz: 0, length_in: 12, width_in: 10, height_in: 6 } },
  { key: "large", label: "Large box", v: { weight_lb: 10, weight_oz: 0, length_in: 18, width_in: 14, height_in: 10 } },
];

const FIELDS = [
  ["weight_lb", "lb"], ["weight_oz", "oz"], ["length_in", "L in"], ["width_in", "W in"], ["height_in", "H in"],
];

const isPreset = (pkg, v) => Object.keys(v).every((k) => Number(pkg[k]) === v[k]);

export default function PackageFields({ draft, patch }) {
  const pkg = draft?.package || {};
  const empty = !FIELDS.some(([k]) => pkg[k] !== undefined && pkg[k] !== "");
  const set = (k, val) => patch({ package: { ...pkg, [k]: val.replace(/[^0-9.]/g, "") } });

  return (
    <div className="rounded-lg border border-slate-200 p-3" data-testid="field-package">
      <div className="mb-2 flex items-center justify-between">
        <Label className="flex items-center gap-1.5 text-[10px] font-mono uppercase tracking-wider text-slate-500">
          <Package className="h-3.5 w-3.5" /> Package weight &amp; size
        </Label>
        <span className="text-[10px] text-slate-400" data-testid="package-default-hint">
          {empty ? "Empty → 1 lb, 12×9×4 in" : "Used for calculated shipping"}
        </span>
      </div>
      <div className="mb-2 flex flex-wrap gap-1.5">
        {PRESETS.map((p) => (
          <button key={p.key} type="button" onClick={() => patch({ package: { ...p.v } })} data-testid={`package-preset-${p.key}`}
            className={`rounded-full border px-2.5 py-1 text-[11px] font-medium transition-colors ${isPreset(pkg, p.v) ? "border-[#0053DA] bg-[#0053DA] text-white" : "border-slate-200 bg-white text-slate-600 hover:border-slate-400"}`}>
            {p.label}
          </button>
        ))}
      </div>
      <div className="grid grid-cols-5 gap-1.5">
        {FIELDS.map(([k, label]) => (
          <div key={k}>
            <Input inputMode="decimal" value={pkg[k] ?? ""} onChange={(e) => set(k, e.target.value)}
              placeholder={label} aria-label={label} data-testid={`package-${k}`} className="h-9 px-2 text-center text-sm" />
            <span className="mt-0.5 block text-center text-[9px] font-mono uppercase text-slate-400">{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
